import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class contactUsModel extends Model {

    defaults() {
        return {
        }
    }

    options() {
        return {
            methods: {
                contactUs: 'GET',
            }
        }
    }

    routes() {
        return {
            contactUs: 'interpreter/contactUs',
        }
    }

    getContactUs() {
        let headers = {
            Bearer: localStorage.getItem('jwt')
        };
        let method = this.getOption('methods.contactUs');
        let route = Vue.prototype.$interpretersApiUrl + '/' + this.getRoute('contactUs');
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        return this.getRequest({headers, method, url}).send();
    }
}
